export enum TaxExemptions {
  EXEMPTION = 'EXEMPTION',
  NOT_SUBJECT = 'NOT_SUBJECT',
  SUBJECT_INVERSION = 'SUBJECT_INVERSION',
  NOT_SUBJECT_INVERSION = 'NOT_SUBJECT_INVERSION',
  SUBJECT_BASIC_DEFAULT = 'SUBJECT_BASIC_DEFAULT',
}
